module.exports = {
    publicPath : process.env.NODE_ENV === 'production' ? '/private/samples/vue/' : '/vue/',
    baseUrl : process.env.NODE_ENV === 'production' ? '/private/samples/vue/' : '/vue/',

    pwa : {
		themeColor : '#F26524'
	},

    pluginOptions: {
      s3Deploy: {
        registry: undefined,
        awsProfile: 'Eventboost',
        region: 'eu-west-1',
        bucket: 'dev.eventboost.io',
        createBucket: false,
        staticHosting: false,
        assetPath: 'dist',
        assetMatch: '**',
        deployPath: '/private/samples/vue',
        acl: 'public-read',
        pwa: true,
        pwaFiles: 'service-worker.js',
        enableCloudfront: true,
        cloudfrontId: 'E3TPP1CD3JUHFQ',
        cloudfrontMatchers: '/private/samples/vue/*',
        uploadConcurrency: 5,
        pluginVersion: '3.0.0'
      }
    }
}
